export const CHANNELS = [
  { v: "phone", label: "Phone" },
  { v: "email", label: "Email" },
  { v: "whatsapp", label: "WhatsApp" },
  { v: "letter", label: "Letter / LPO" },
  { v: "walk-in", label: "Walk-in" },
  { v: "other", label: "Other" },
];
export const channelLabel = (v) => CHANNELS.find((c) => c.v === v)?.label || v;
export const orderBadge = (s) => ({ fulfilled: "ok", cancelled: "out", dispatched: "dispatched", pending_review: "discrepancy" }[s] || "pending");
const LABELS = { pending_review: "Pending Review", dispatched: "Dispatched", fulfilled: "Fulfilled", cancelled: "Cancelled", fulfilling: "Fulfilling" };
export const statusLabel = (o) => (o.status === "pending" ? (o.fulfilment_type === "virtual" ? "Pending Delivery" : "Pending") : LABELS[o.status] || o.status);
export const BASIS_LABEL = { received: "Accepted received quantities", dispatched: "Accepted dispatched quantities", ordered: "Accepted ordered quantities", cancel: "Order cancelled" };
export const pct = (v) => (v == null ? "—" : `${v}%`);
export const today = () => new Date().toISOString().slice(0, 10);

export const CreditBar = ({ pct }) => (
  <div className="h-1.5 w-full rounded-full bg-muted overflow-hidden">
    <div className={`h-full ${pct >= 90 ? "bg-rose-500" : pct >= 70 ? "bg-amber-500" : "bg-emerald-500"}`} style={{ width: `${Math.min(100, pct)}%` }} />
  </div>
);

export const TypeTag = ({ t, testId }) => {
  const v = t === "virtual";
  return (
    <span data-testid={testId} className={`inline-block rounded px-1.5 py-0.5 text-[10px] font-medium uppercase tracking-wide ${v ? "bg-sky-100 text-sky-800 dark:bg-sky-500/15 dark:text-sky-300" : "bg-stone-200 text-stone-700 dark:bg-stone-500/20 dark:text-stone-300"}`}>
      {v ? "Virtual" : "Physical"}
    </span>
  );
};
